import { styled, TextField, TextFieldProps } from '@mui/material';

export type PercentageInputVariant = 'default';

export type StyledPercentageInputProps = Omit<TextFieldProps, 'variant'> & {
  customVariant?: PercentageInputVariant;
};

export const StyledPercentageInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'customVariant',
})<StyledPercentageInputProps>({});
